// extracted by mini-css-extract-plugin
module.exports = {"isSuccess":"RepRequestRecommendedSellersButton_isSuccess__B7SJF typeography_ui12SemiBold__3xcry"};